export default __webpack_public_path__ + "static/liftmate-screenshot-be2e9a86adc006376e05996a4334c0c1.png";